import React, {useState, useEffect} from 'react';
import PageInfoStore from './flux/PageInfoStore';
import MainSubNav from './MainSubNav';
// import MainNavButtons from './MainNavButtons';

export default function MainNav(props) {
  const mainMenu = props.navJSON['main-menu'];
  const header = document.getElementById('shopify-section-header');
  const [selectedMainCat, setSelectedMainCat] = useState(false);
  const [currentMenuHeight, setCurrentMenuHeight] = useState(false);

  // console.log(cartJSON);

  useEffect(() => {
    const emitter = PageInfoStore.addListener('scrollDirection', () => {
      const dir = PageInfoStore.getScrollDirection();
      if(dir === 'down') { setMainCatSubMenu(false) };
    });
    return () => { emitter.remove(); }
  });

  useEffect(() => {
    const emitter2 = PageInfoStore.addListener('menuHeights', () => {
      const menuHeights = PageInfoStore.getMenuHeights();
      setCurrentMenuHeight(menuHeights[selectedMainCat]);
    });
    return () => { emitter2.remove(); }
  });

  useEffect(() => {
    const emitter3 = PageInfoStore.addListener('selectedSubMenu', () => {
      setSelectedMainCat(PageInfoStore.getSelectedSubMenu());
    });
    return () => { emitter3.remove(); }
  });

  function setMainCatSubMenu(handle) {
    PageInfoStore.setSelectedSubMenu(handle);
  }

  function renderSubMenu(menuItem) {
    let heightStyle = 0;
    if (menuItem.handle === selectedMainCat) {
      if (currentMenuHeight) {
        heightStyle = `${currentMenuHeight}px`;
      } else {
        heightStyle = '500px';
      }
    }

    return (
      <div
        className="subMenu"
        style={{ 
          top: header.offsetHeight,
          height: heightStyle,
        }}
        // onMouseLeave={() => { setMainCatSubMenu(false); }}
      >
        <span className="menu-container">
            {menuItem.handle === selectedMainCat ? <MainSubNav category={menuItem} /> : ''}
        </span>
      </div>
    );
  }

  function renderDownArrow() { return <span className="downArrow" /> }
  
  function renderCloseArea() {
    return (
      <span
        className="close-target"
        style={{ top: header.offsetHeight, }}
        onClick={() => { setMainCatSubMenu(false) }}
        // onMouseEnter={() => { setMainCatSubMenu(false) }}
      />
    ) 
  }
  
  return (
    <div className="slMainNav">
      <nav class="header__inline-menu">
        <ul class="list-menu list-menu--inline">
          {mainMenu.map((menuItem) => {
            const current = menuItem.current;
            const title = menuItem.title.replaceAll('&amp;', '&');
            // let hover = false;
            return (
              <li 
                key={menuItem.order}
                onMouseEnter={((e) => {
                  if(menuItem.children.length > 0) {
                    setMainCatSubMenu(menuItem.handle);
                  } else {
                    setMainCatSubMenu(false);
                  }
                })}
                className={menuItem.handle === selectedMainCat ? 'main-cat selected' : 'main-cat'}
              >
                <a
                  href={menuItem.url}
                  className="header__menu-item header__menu-item list-menu__item link link--text focus-inset"
                  aria-current={current === 'true' ? 'page' : 'false'}
                  onClick={((e) => {
                    if(menuItem.children.length > 0) {
                      e.preventDefault();
                      setMainCatSubMenu(menuItem.handle);
                    }
                  })}
                >
                  <span className={current === 'true' ? 'header__active-menu-item' : ''}>
                    {title}
                    {menuItem.children.length > 0 ? renderDownArrow() : ''}
                  </span>
                </a>
                {menuItem.children.length > 0 ? renderSubMenu(menuItem) : ''}
              </li>
            )
          })}
        </ul>
        {/* <MainNavButtons /> */}
      </nav>
      {selectedMainCat ? renderCloseArea() : ''}
    </div>
  );
}